import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import gql from 'graphql-tag';
import { AdminLayout, AdminHeader, AdminNavbar, BuilderBlogControls } from '../../../../layout';
import classes from './AdminBlog.scss';

const propTypes = {
  children: PropTypes.node,
  loading: PropTypes.bool.isRequired,
  site: PropTypes.shape({
    blogSettings: PropTypes.shape({
      enabled: PropTypes.bool.isRequired,
    }).isRequired,
  }).isRequired,
};

const defaultProps = {
  children: undefined,
};

const AdminBlog = ({ children, site: { blogSettings: { enabled } } }) => {
  const header = (
    <AdminHeader title="Blog">
      <BuilderBlogControls />
    </AdminHeader>
  );

  const add = {
    disabled: true,
    authorization: {},
  };

  const navbar = (
    <AdminNavbar
      add={add}
      blog={{ active: true }}
    />
  );

  return (
    <AdminLayout header={header} navbar={navbar}>
      <Helmet>
        <title>Blog</title>
      </Helmet>
      {!enabled ? (
        <div className={classes.overlay}>
          <div className={classes.description}>
            Blog must be activated in order to make changes to
            it. Activate by clicking the "Activate" button on the
            top right of the screen.
          </div>
        </div>
      ) : false}
      <div className={classes.root}>
        {children}
      </div>
    </AdminLayout>
  );
};

AdminBlog.propTypes = propTypes;
AdminBlog.defaultProps = defaultProps;

AdminBlog.fragments = {
  currentSite: gql`
    fragment CurrentSiteBlogData on Site {
      blogSettings {
        enabled
      }
    }
  `,
};

export default AdminBlog;
